import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import { WarrantMeterExchangeEligibility } from "@/api/backofficeRest/generated/model"
import { IWarrantMeterExchangeEligibility } from "@/models/warrantMeterExchange/warrantMeterExchange.types"

const EMPTY_ELIGIBILITY: IWarrantMeterExchangeEligibility = {
  isReadyForMeterExchange: false,
  canBeRecalledFromExchange: false,
  hasMeterExchangeTicket: false,
}

export interface IWarrantMeterExchangeService {
  getEligibility(
    billingAccountId: number | null,
  ): QueryResult<IWarrantMeterExchangeEligibility>
}

class WarrantMeterExchangeServiceClass implements IWarrantMeterExchangeService {
  getEligibility(
    billingAccountId: number | null,
  ): QueryResult<IWarrantMeterExchangeEligibility> {
    return useQuery<
      WarrantMeterExchangeEligibility,
      IWarrantMeterExchangeEligibility
    >({
      ...BackofficeRestQueries.warrants.meterExchangeEligibility(
        billingAccountId ?? -1,
      ),
      useRawResponse: true,
      placeholderData: EMPTY_ELIGIBILITY,
      enabled: !!billingAccountId,
      parserFn: (raw) => ({
        isReadyForMeterExchange: raw.isReadyForMeterExchange,
        canBeRecalledFromExchange: raw.canBeRecalledFromExchange,
        hasMeterExchangeTicket: raw.hasMeterExchangeTicket,
      }),
    })
  }
}

export const WarrantMeterExchangeService =
  new WarrantMeterExchangeServiceClass()
